module.exports = {
  roomOnlyPriceText: 'Zimmerpreis ohne Parken',
  includingOneWeekParkingText: 'Inkl. 1 Woche Parken',
  carParkText: 'Parkplatz',
  hotelText: 'Hotel',
  starsText: 'Sterne',
  distanceText: 'Entfernung',
  transfersText: 'Transfer',
  loungeText: 'Lounge',
  timesText: 'Zeiten',
  ratingText: 'Bewertung',
  priceText: 'Preis',
  pricePerDayText: 'Preis pro Tag',
  pricePerWeekText: 'Preis pro Woche',
  notRequiredText: 'Nicht erforderlich',
  minutesShortText: 'Minuten',
  includedText: 'inklusive',
  milesText: 'Kilometer',
  onAirportText: 'Direkt am Flughafen',
  mapAndDirectionsText: 'Karte und Anfahrt',
  photosText: 'Fotos',
  videoText: 'Video',
  reviewsText: 'Bewertungen',
  customerReviewsText: 'Kundenbewertungen',
  thisIsAGuidePriceOnlyText: 'Das ist nur ein Richtpreis.',
  loungeOpenTimesText: 'Diese Lounge ist von OPENINGTIME bis CLOSINGTIME geöffnet.',
  loungeOpenTimesShortText: 'von <strong>OPENINGTIME</strong> bis <strong>CLOSINGTIME</strong>',
  bookAgainText: 'AVERAGEASPERCENTAGE% von insg. COUNT Bewertungen sprechen sich dafür aus dieses Produkt wieder zu buchen.',
  carParkingCaveat: '*Dies ist ein Preisbeispiel für Reservierungen zwischen STARTDATE und ENDDATE, gültig am DATEUSED. Der Preis pro Woche beinhaltet die Gesamtkosten für diesen Parkplatz für 8 Tage. Der Preis pro Tag bezieht sich auf dasselbe Produkt und dieselbe Zeit, geteilt durch 8.',
  otherCaveat: '*Dies ist ein Preisbeispiel für eine Reservierung am STARTDATE, gültig am DATEUSED.',
  lowestPriceOnlyLabel: 'From '
}



// WEBPACK FOOTER //
// ./shared/config/components/productList/nl/index.js